export const readingList = [
  {
    Title: "Data Rhetoric and Uneasy Alliances",
    "Content type": "article",
    Authors: "Vera Khovanskaya, Phoebe Sengers",
    Date: "18/06/2019",
    Publication:
      "Proceedings of the 2019 on Designing Interactive Systems Conference",
    Link: "https://dl.acm.org/doi/abs/10.1145/3322276.3323691",
  },
  {
    Title:
      "Post-work Futures and Full Automation: Towards a Feminist Design Methodology",
    "Content type": "article",
    Authors: "Sarah Elsie Baker",
    Date: "01/12/2018",
    Publication: "Open Cultural Studies",
    Link: "https://www.degruyter.com/document/doi/10.1515/culture-2018-0049/html",
  },
  {
    Title: "Scandinavian Design: On Participation and Skill",
    "Content type": "article",
    Authors: "Pelle Ehn",
    Date: "14/12/2017",
    Publication: "Participatory Design",
    Link: "https://www.taylorfrancis.com/chapters/edit/10.1201/9780203744338-4/scandinavian-design-participation-skill-pelle-ehn",
  },
];
